import React, { useState } from "react";
import "./FAQ.css";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What is TRAVNOK?",
      answer:
        "TRAVNOK is a comprehensive travel CRM and software suite designed specifically for travel businesses, agencies, tour operators, and DMCs. It combines powerful CRM capabilities with integrated booking engines, lead management, and analytics to help travel businesses streamline operations and grow revenue.",
    },
    {
      question: "How does TRAVNOK improve tour management?",
      answer:
        "TRAVNOK improves tour management by providing automated workflows, real-time availability tracking, integrated booking systems, customer communication tools, and comprehensive analytics. It reduces manual work, minimizes errors, and provides better visibility into your business operations.",
    },
    {
      question: "Can TRAVNOK be customized for different travel businesses?",
      answer:
        "Yes, TRAVNOK is highly customizable and can be tailored to fit the specific needs of different travel businesses including travel agencies, tour operators, DMCs, hotels, and other travel service providers. The platform offers flexible configurations and custom workflows.",
    },
    {
      question:
        "How does TRAVNOK capture leads, and what lead integration options are available?",
      answer:
        "TRAVNOK captures leads through multiple channels including website forms, social media, email campaigns, and direct imports. It offers integration with popular platforms like Facebook, Google Ads, WhatsApp, and can connect with your existing website forms through API or embeddable widgets.",
    },
    {
      question: "Is my data secure with TRAVNOK?",
      answer:
        "Absolutely. TRAVNOK uses enterprise-grade security with encrypted data storage, regular backups, and compliance with industry standards. Your data is stored on secure cloud servers with 24/7 monitoring and protection against cyber threats.",
    },
    {
      question: "What kind of support is available?",
      answer:
        "We offer comprehensive support including 24/7 technical support, dedicated account managers, training sessions, video tutorials, and detailed documentation. Our support team is available via email, phone, and live chat.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      {faqs.map((faq, index) => (
        <div key={index} className="faq-item">
          <button
            className={`faq-question ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleAccordion(index)}
          >
            <span>{faq.question}</span>
            <i
              className={`fas ${activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"}`}
            ></i>
          </button>
          <div
            className={`faq-answer ${activeIndex === index ? "active" : ""}`}
          >
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FAQ;
